export const mutations = {
    setGrupoProduto(state, grupo){
        state.grupoProduto = grupo
    },
    setGruposProduto(state, grupos){
        state.gruposProduto = grupos
    },
    setModalCadastroGrupoProduto(state, status){
        state.modalCadastroGrupoProduto = status
    },
    setModalExcluirGrupoProduto(state, status){
        state.modalExcluirGrupoProduto = status
    }
}

export default {}